import state from './state';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

/**
 * Vuex store for Medication DSS
 *
 * @namespace vuex-DSS
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/store/dss/index.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };